import React from 'react';

import {
  useLocation,
  useNavigate,
  useParams,
} from 'react-router-dom';
import styled from 'styled-components';
import {
    BodyContainer,
    Contents,
    Header,
    MainContainer, Overlay,
    SideMenu,
} from 'view/components';
import Details from 'view/pages/Create/components/tab/Details';
import InstructorMessage
  from 'view/pages/Create/components/tab/InstructorMessage';
import LearingMaterial from 'view/pages/Create/components/tab/LearingMaterial';
import Overview from 'view/pages/Create/components/tab/Overview';
import Quiz from 'view/pages/Create/components/tab/Quiz';
import Videos from 'view/pages/Create/components/tab/Videos';
import {isEmpty} from "../../../util";

interface StyledComponentProps {
    width?: string;
    display?: string;
}

interface CreateProps {
    selected?: any;
}

const Create: React.FC<CreateProps> = () => {
    const location = useLocation();  
    const { step } = useParams();
    const navigate = useNavigate()

    console.log('step', step)

    const components = () => {
        switch (step) {
            case "details": {
                return <Details />;
            }
            case "overview": {
                return <Overview />;
            }            
            case "learning material": {
                return <LearingMaterial />;
            }
            case "videos": {
                return <Videos />;
            }
            case "quiz": {
                return <Quiz />;
            }
            case "instructor message": {
                return <InstructorMessage />;
            }
            default:
                break;
        }
    };

    const onClickSideMenu = (step) => {        
        navigate(`/create/${step}`,{
            state: { createId : location?.state?.createId || "" }
        })
    }

    return (
        <Container>
            <BodyContainer>
                {
                    isEmpty(location?.state?.createId) &&
                    <Overlay filter={true}>
                        <></>
                    </Overlay>
                }
                <ContentsWrap>
                    <SideMenu onClick={onClickSideMenu} selected={step} />
                    <Wrap>
                        <Header />
                        <MainContainer>
                            <div className={"main_inner"} style={{ padding: 30 }}>
                                <Contents title={step}>{components()}</Contents>
                            </div>
                        </MainContainer>
                    </Wrap>
                </ContentsWrap>
            </BodyContainer>
        </Container>
    );
};
export default Create;

const Container = styled.div`
    display: flex;
`;
const ContentsWrap = styled.div`
    display: flex;
    width: calc(100% - 298);
    max-width: 1440px;
    height: 100%;
    margin: auto;
`;

const Wrap = styled.div`
    width: 100%;
    height: 100%;
    overflow-y: hidden;
    flex: 1;
    .commonContentsHeader{
        font-size: 22px;
        font-family: "Europa-Bold";
        font-weight: 700;
        line-height: 22px;
        letter-spacing: 0em;
        text-align: left;
        padding: 0.84rem 1.5rem;
        min-height: 50px;
    }
    @media screen and (max-width: 768px) {
        //flex-direction: column;
        //width: 100%;
        //& > div{
        //    width: 100%;
        //}
        .main_inner{
            padding-top: 20px!important;
            padding-left: 20px!important;
            padding-right: 20px!important;
            padding-bottom: 20px!important;
        }
        position: absolute;
    }
`;